import { TextH1, TextH2, Text } from "@/components/Text";
import useInApp from "@/hooks/useIsApp";
import clientDeepLinks from "@/utils/clientDeepLinks";
import clsx from "clsx";
import React from "react";

interface SurveyTitleProps {
	title: string;
	subtitle?: string | React.ReactNode;
	subNode?: React.ReactNode;
	linkTitle?: string;
	linkUrl?: string;
	space?: boolean;
}

function SurveyTitleV2({ title, subtitle, subNode, linkTitle, linkUrl, space }: SurveyTitleProps) {
	const isInApp = useInApp();

	const handleLink = () => {
		if (!linkUrl) return;
		let _linkUrl = linkUrl;
		if (isInApp) {
			_linkUrl = clientDeepLinks.webview(linkUrl);
		}
		window.location.href = _linkUrl;
	};

	return (
		<div className={clsx("pt-[2.4vh]", space ? "px-4.5" : "")}>
			<TextH1 className="rf-page-ani rf-page-ani-delay-0">{title}</TextH1>

			{subtitle && <TextH2 className="mt-4 rf-page-ani rf-page-ani-delay-1">{subtitle}</TextH2>}
			{subNode && <TextH2 className="mt-4 rf-page-ani rf-page-ani-delay-1">{subNode}</TextH2>}

			{linkTitle && (
				<Text
					className="mt-3 block font-semibold rf-page-ani rf-page-ani-delay-1 cursor-pointer"
					onClick={() => handleLink()}
				>
					{linkTitle}
				</Text>
			)}
		</div>
	);
}

export default SurveyTitleV2;
